import BaseSwal from "sweetalert2";

/** Applied to every dialog; colors live in src/assets/style.css (.orbi-swal-*) */
const BUTTON_CLASSES = {
  confirmButton: "orbi-swal-confirm",
  cancelButton: "orbi-swal-cancel",
};

const Swal = BaseSwal.mixin({
  customClass: BUTTON_CLASSES,
});

const originalFire = Swal.fire.bind(Swal);

Swal.fire = async (...args) => {
  // Support Swal.fire(title, text, icon) and Swal.fire(options)
  let options = {};
  const first = args[0];
  if (first && typeof first === "object" && !Array.isArray(first)) {
    options = { ...first };
  } else {
    const [title, text, icon] = args;
    options = { title, text, icon };
  }

  const cc = options.customClass || {};
  options.customClass = {
    ...cc,
    confirmButton: [BUTTON_CLASSES.confirmButton, cc.confirmButton].filter(Boolean).join(" ").trim(),
    cancelButton: [BUTTON_CLASSES.cancelButton, cc.cancelButton].filter(Boolean).join(" ").trim(),
  };

  // Theme from CSS only — SweetAlert inline colors would override classes
  delete options.confirmButtonColor;
  delete options.cancelButtonColor;

  // Confirm dialogs should show warning icon
  if (options.showCancelButton) {
    options.icon = "warning";
  }

  // Convert toast notifications to centered SweetAlert popups.
  // This keeps existing text/icon/timer behavior, but shows in center.
  if (options.toast) {
    // Most toast calls pass `title`; for modal-style alerts use body text
    // so the message appears compact and easier to read.
    if (!options.text && options.title) {
      options.text = options.title;
      options.title = "";
    }
    options.toast = false;
    options.position = "center";
    options.width = options.width || "28rem";
    options.customClass = {
      ...options.customClass,
      popup: `${options.customClass?.popup || ""} swal-compact-popup`.trim(),
      htmlContainer: `${options.customClass?.htmlContainer || ""} swal-compact-content`.trim(),
      title: `${options.customClass?.title || ""} swal-compact-title`.trim(),
    };
  }

  return await originalFire(options);
};

export default Swal;
